import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import "../../CSS/HomeCSS/cardslider.css";
import "../../CSS/HomeCSS/blogs.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchRace, STATUSES } from "../../../redux/getReducer/getRaceCard";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';

// Country flag assets
import uaeFlag from "../../../assets/United Arab Emirates.png";
import ukFlag from "../../../assets/GB.jpg";
import franceFlag from "../../../assets/France.png";

const RaceCardSlider = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id, date } = useParams();
  const { data: racecard, status } = useSelector((state) => state.racecard);
  const { t } = useTranslation();
  const cookiedata = Cookies.get("i18next");
  const [, setTick] = useState(0);

  useEffect(() => {
    dispatch(fetchRace());
  }, [dispatch]);

  // Re-calculate remaining time every 15 seconds
  useEffect(() => {
    const timer = setInterval(() => setTick((v) => v + 1), 15000);
    return () => clearInterval(timer);
  }, []);

  function HandleJockey(raceId) {
    navigate(`/race-detail?${raceId}`);
    setTimeout(() => {
      const scrollY = window.innerWidth <= 530 ? 2500 : 150;
      window.scrollTo({ top: scrollY, behavior: "smooth" });
    }, 500);
  }

  const getRemainingBadge = (startTime, timeRemaining) => {
    if (!startTime) return { label: "UPCOMING", isLive: false };
    const now = moment();
    const start = moment(startTime);
    const diffMinutes = start.diff(now, 'minutes');

    if (diffMinutes <= 0) {
      if (timeRemaining && timeRemaining.charAt(0) === "-") {
        return { label: "RESULT", isLive: false };
      }
      return { label: "LIVE", isLive: true };
    }

    if (diffMinutes < 60) {
      return { label: `${diffMinutes} MINS`, isLive: false };
    }

    const hours = Math.floor(diffMinutes / 60);
    const mins = diffMinutes % 60;
    return {
      label: `${hours}H ${mins > 0 ? `${mins}M` : ''}`.trim(),
      isLive: false
    };
  };

  const formatRaceTime = (startTime) => {
    if (!startTime) return "";
    return moment(startTime).format("HH:mm");
  };

  const getCountryFlag = (nationality) => {
    const name = (nationality?.NameEn || "").toLowerCase();
    if (name.includes("emirates") || name.includes("uae") || name.includes("dubai") || name.includes("arab")) {
      return uaeFlag;
    }
    if (name.includes("kingdom") || name.includes("britain") || name.includes("uk") || name.includes("gb")) {
      return ukFlag;
    }
    if (name.includes("france")) {
      return franceFlag;
    }
    if (nationality?.image) {
      return nationality.image;
    }
    return uaeFlag;
  };

  if (status === STATUSES.LOADING) {
    return <div></div>;
  }

  if (status === STATUSES.ERROR) {
    return <h2 style={{ margin: "100px" }}>Something went wrong!</h2>;
  }

  const breakpoints = {
    1920: { slidesPerView: 4.5 },
    1600: { slidesPerView: 4 },
    1366: { slidesPerView: 3.5 },
    1024: { slidesPerView: 3 },
    768: { slidesPerView: 2.2 },
    480: { slidesPerView: 1.4 },
    320: { slidesPerView: 1.15 },
  };

  return (
    <div className="new-race-slider-main-wrapper">
      <div className="new-slider-container">
        {racecard && racecard.length > 0 ? (
          <Swiper
            breakpoints={breakpoints}
            spaceBetween={14}
            navigation={true}
            modules={[Navigation]}
            className="mySwiper new-swiper-override"
          >
            {racecard.map((item, i) => {
              const badge = getRemainingBadge(item.StartTime, item.TimeRemaining);
              const trackName = cookiedata === "en"
                ? (item.RaceCourseData?.TrackNameEn || item.RaceNameModelData?.NameEn || "Race")
                : (item.RaceCourseData?.TrackNameAr || item.RaceNameModelData?.NameAr || "سباق");
              const raceTypeName = cookiedata === "en" 
                ? item.RaceNameModelData?.NameEn 
                : item.RaceNameModelData?.NameAr;

              return (
                <SwiperSlide key={item._id || i}>
                  <div
                    className="modern-race-slider-card"
                    onClick={() => HandleJockey(item._id)}
                  >
                    {/* Top Row: Badge (Time remaining) & Country Flag */}
                    <div className="modern-race-card-top">
                      <span className={`modern-race-badge ${badge.isLive ? 'is-live' : ''}`}>
                        {badge.label}
                      </span>

                      <div className="modern-race-flag-wrap">
                        <img
                          src={getCountryFlag(item.RaceCourseData?.NationalityDataRaceCourse)}
                          alt="Flag"
                          className="modern-race-flag-img"
                        />
                      </div>
                    </div>

                    {/* Middle: Race Time & Track Name */}
                    <div className="modern-race-card-main">
                      <h4 className="modern-race-title-line">
                        <span className="modern-race-time">{formatRaceTime(item.StartTime)}</span>
                        <span className="modern-race-track">{trackName}</span>
                      </h4>

                      {/* Bottom: Race #, Track length / description */}
                      <p className="modern-race-subtitle-line">
                        <span className="modern-race-number-tag">
                          {item.RaceNumber ? `${t("Race")} ${item.RaceNumber}` : ""}
                        </span>
                        {item.TrackLengthData?.TrackLength ? (
                          <span className="modern-race-dist"> | {item.TrackLengthData.TrackLength}m</span>
                        ) : null}
                        {raceTypeName ? (
                          <span className="modern-race-desc"> | {raceTypeName}</span>
                        ) : null}
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        ) : null}
      </div>
    </div>
  );
};

export default RaceCardSlider;
